import Link from "next/link";

import type { BreadcrumbItem } from "@/lib/seo/schema";

const Chevron = () => (
  <svg
    aria-hidden="true"
    viewBox="0 0 24 24"
    fill="none"
    className="size-3 shrink-0 text-gray-400"
  >
    <path
      d="M9 6l6 6-6 6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BlogBreadcrumbs = ({ items }: { items: BreadcrumbItem[] }) => {
  if (!items.length) return null;

  return (
    <nav aria-label="Breadcrumb" className="w-full">
      <ol className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-xs text-gray-500">
        {items.map((item, index) => {
          const last = index === items.length - 1;
          return (
            <li key={`${item.href}-${index}`} className="flex items-center gap-x-2">
              {index > 0 && <Chevron />}
              {last ? (
                <span aria-current="page" className="text-gray-900">
                  {item.name}
                </span>
              ) : (
                <Link href={item.href} className="transition-colors hover:text-gray-900">
                  {item.name}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};
